import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sun, Loader2, Play } from "lucide-react";
import api from "@/lib/api";
import { fmtDateTime, formatApiErrorDetail } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { todayIso } from "@/lib/cantieri";

// Riepilogo del mattino (7:30): l'IA controlla agenda, cantieri e pagamenti e avvisa con notifica + email.
export const BriefingCard = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/agent/briefing/latest").then((r) => setS(r.data)).catch(() => {}); }, []);
  const toggle = async (k, v) => { setS((x) => ({ ...x, [k === "briefing_enabled" ? "enabled" : "email"]: v })); await api.put("/agent/briefing/settings", { [k]: v }); };
  const run = async () => {
    setBusy(true);
    try { const r = await api.post("/agent/briefing/run"); setS((x) => ({ ...x, briefing: r.data })); toast.success("Riepilogo generato e inviato"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!s) return null;
  const b = s.briefing?.data === todayIso() ? s.briefing : null;
  return (
    <div className="rounded-xl border border-amber-200/70 bg-amber-50/60 dark:bg-amber-950/20 dark:border-amber-900/50 p-4 space-y-3" data-testid="briefing-card">
      <div className="flex items-center gap-2 flex-wrap">
        <Sun className="w-5 h-5 text-amber-500" />
        <div className="font-heading font-semibold flex-1 min-w-[180px]">Riepilogo del mattino · ore 7:30</div>
        <label className="flex items-center gap-1.5 text-xs"><Switch checked={s.enabled} onCheckedChange={(v) => toggle("briefing_enabled", v)} data-testid="briefing-enabled-switch" /> Attivo</label>
        <label className="flex items-center gap-1.5 text-xs"><Switch checked={s.email} onCheckedChange={(v) => toggle("briefing_email", v)} data-testid="briefing-email-switch" /> Anche via email</label>
        <Button size="sm" variant="outline" onClick={run} disabled={busy} data-testid="briefing-run-button">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Play className="w-3.5 h-3.5 mr-1" /> Genera ora</>}</Button>
      </div>
      {b ? (
        <div>
          <div className="text-xs text-muted-foreground mb-1">{fmtDateTime(b.created_at)} · {b.titolo}</div>
          <p className="text-sm whitespace-pre-wrap leading-relaxed line-clamp-[10]" data-no-translate data-testid="briefing-text">{b.testo}</p>
        </div>
      ) : <p className="text-sm text-muted-foreground" data-testid="briefing-empty">Il riepilogo di oggi non è ancora pronto: premi «Genera ora». Ogni mattina ti arriva una notifica con appuntamenti, cantieri e pagamenti del giorno.</p>}
    </div>
  );
};

export default BriefingCard;
